import Vue from 'vue'
import Router from 'vue-router'
import HomeView from '../views/Home.vue'
import IndexView from '../views/Index.vue'
import AdminView from '../views/Admin.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/map',
      name: 'map',
      component: IndexView
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminView
    }
  ]
})
